// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wkw80","newExpiryDate":"styles_newExpiryDate__2rpub","footer":"styles_footer__3F4VC"};